import { toISOString } from '@/utils/date';
import request from '@/utils/request';

export function getRolls(fabricOrderLineID) {
  return request({
    method: 'get',
    url: `fabricorderline/${fabricOrderLineID}/rolls`
  });
}

export function saveRolls(command) {
  return request({
    method: 'post',
    url: 'fabricorderline/rolls',
    data: command
  });
}

function transformItem2Dto(item) {
  const dto = {
    fabricOrderLineID: item.id,
    ...item,
    estimatedDepartureAt: toISOString(item.estimatedDepartureAt),
    estimatedDeliveryAt: toISOString(item.estimatedDeliveryAt)
  };
  delete dto.id;
  return dto;
}

export const storeExtensions = {
  actions: {
    getRolls({ dispatch }, { fabricOrderLineID }) {
      return new Promise((resolve, reject) =>
        getRolls(fabricOrderLineID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    saveRolls({ dispatch }, command) {
      return new Promise((resolve, reject) =>
        saveRolls(command)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};

export const apiOverrides = { transformItem2Dto };
